/**
 * RISKS-V2
 * Represents the types and interfaces used in the risks feature.
 */
import { RiskFamily } from "@/entities/risk-family/model/risk-family.types"
import { v4 as uuid } from "uuid"

export const PHYSICAL_RISK_ENTITY = "physicalRisk"
/** Param d'URL portant le risque tout juste cree : la carte correspondante s'anime la ou elle est visible. */
export const NEWLY_ADDED_RISK_PARAM = "added"
export type RiskType = "psy" | "phy"

/** Valeur d'un attribut de risque, resolue depuis les reglages du compte (id de stockage + libelle) */
export interface PhysicalRiskAttribute {
  id: string
  name: string
  value: string
}

/** Gravite et frequence propres a une fonction du risque ; vides, la fonction prend celles du risque */
export interface PhysicalRiskPopulationEvaluation {
  PopulationId: string
  severity: number | null
  frequency: number | null
}

export interface PhysicalRisk {
  id: string
  //Cle = id de l'attribut (accountRisksSettings.riskAttributes), jamais son libelle
  attributes: Record<string, string>
  frequency: number
  severity: number
  prevention: number
  photoId: string | null
  updatedAt: Date | null
  siteIds: string[]
  populationIds: string[]
  //Seulement les fonctions qui ont une evaluation propre
  populationEvaluations: PhysicalRiskPopulationEvaluation[]

  //Keys
  RiskFamilyId: string | null
  EstablishmentId: string | null

  //Calculated fields
  cAttributes: PhysicalRiskAttribute[]
  cFamily: RiskFamily | null
  cSize: number
  cName: string
  cSeverityLabel: string
  cFrequencyLabel: string
  cPreventionLabel: string
  cSeverityScale: PhysicalRiskScaleItem[]
  cFrequencyScale: PhysicalRiskScaleItem[]
  cPreventionScale: PhysicalRiskScaleItem[]
  cValueInitial: number | null
  cValueInitialLabel: string | null
  cValueInitialColor: string | null
  cValueEffective: number | null
  cValueEffectiveLabel: string | null
  cValueEffectiveColor: string | null
  cValueEffectiveIndex: number
  cValueNormalized: number | null
}

// === Risk scales ===
export interface PhysicalRiskScaleItem {
  label: string
  description: string
  value: number
}

export const createEmptyPhysicalRisk = (overrides?: Partial<PhysicalRisk>): PhysicalRisk => {
  const defaultPhysicalRisk: PhysicalRisk = {
    id: uuid(),
    attributes: {},
    frequency: 2,
    severity: 1,
    prevention: 1,
    photoId: null,
    updatedAt: null,
    siteIds: [],
    populationIds: [],
    populationEvaluations: [],

    //Relations
    RiskFamilyId: null,
    EstablishmentId: null,

    //Calculated fields
    cAttributes: [],
    cFamily: null,
    cSize: 0,
    cName: "",
    cSeverityLabel: "",
    cFrequencyLabel: "",
    cPreventionLabel: "",
    cSeverityScale: [],
    cFrequencyScale: [],
    cPreventionScale: [],
    cValueInitial: null,
    cValueInitialLabel: null,
    cValueInitialColor: null,
    cValueEffective: null,
    cValueEffectiveLabel: null,
    cValueEffectiveColor: null,
    cValueEffectiveIndex: 0,
    cValueNormalized: null
  }

  return {
    ...defaultPhysicalRisk,
    ...overrides
  }
}

export type PhysicalRiskEvaluationType = "severity" | "frequency" | "prevention"
